import { trigger, state, animate, style, transition, query } from '@angular/animations';



export const inOutAnimation =
  trigger('inOutAnimation',
    [
      transition(
        ':enter',
        [
          style({ height: 0, opacity: 0 }),
          animate('.4s ease-out', style({ height: '*', opacity: 1 }))
        ]
      ),
      transition(
        ':leave',
        [
          style({ opacity: 1 }),
          animate('.4s ease-in', style({ height: 0, opacity: 0 }))
        ]
      )
    ]
  )
export const inOutScaleAnimation =
  trigger('inOutScaleAnimation',
    [
      transition(
        ':enter',
        [
          style({ opacity: 0 }),
          animate('.4s ease-out', style({ opacity: 1 }))
        ]
      ),
      transition(
        ':leave',
        [
          style({ opacity: 1 }),
          animate('.6s ease-in', style({ opacity: 0 }))
        ]
      )
    ]
  )
export const inOutAnimationSlowly =
  trigger('inOutAnimationSlowly',
    [
      transition(
        ':enter',
        [
          style({ height: 0, opacity: 0 }),
          animate('1.4s ease-out', style({ height: '*', opacity: 1 }))
        ]
      ),
      transition(
        ':leave',
        [
          style({ opacity: 1 }),
          animate('1.4s ease-in', style({ height: 0, opacity: 0 }))
        ]
      )
    ]
  )
export const fadeAnimation = trigger('fadeAnimation', [
  transition('* => *', [
    query(':enter',
      [
        style({ opacity: 0 })
      ],
      { optional: true }
    ),
    query(':leave',
      [
        style({ opacity: 1 }),
        animate('1s', style({ opacity: 0 }))
      ],
      { optional: true }
    ),
    query(':enter',
      [
        style({ opacity: 0 }),
        animate('1s', style({ opacity: 1 }))
      ],
      { optional: true }
    )
  ])
]);
export const slideOpen = trigger(
  'slideOpen', [
  transition(':enter', [
    style({ opacity: 0, height: 0 }),
    animate('400ms', style({ opacity: 1, height: '*' }))
  ]),
  transition(':leave', [
    style({ opacity: 1, height: '*' }),
    animate('400ms', style({ opacity: 0, height: 0 }))
  ])
]
)
